import type { UserPermission, UserRole } from "@/lib/api";
import { canAccessBilling } from "@/lib/billing-access";
import { canSeeRunnerManagement } from "@/lib/runner-access";
import type { MainView } from "@/stores/useLayoutStore";

export type MainViewRouteAuthState = "checking" | "authenticated" | "unauthenticated";

export interface MainViewAccessUser {
	role: UserRole;
	permissions: readonly UserPermission[];
	billingManagedInCloud: boolean;
	deviceManagementAvailable: boolean;
}

/** サイドバーの項目とルートで共通に使う、メインビューの表示可否。 */
export function canAccessMainView(view: MainView, user: MainViewAccessUser): boolean {
	switch (view) {
		case "billing":
			return canAccessBilling(user.role, user.permissions, user.billingManagedInCloud);
		case "organization":
			return user.role === "Admin" || user.role === "SuperAdmin";
		case "devices":
			return canSeeRunnerManagement(user.role, user.deviceManagementAvailable);
		default:
			return true;
	}
}

/** メインビューのルートへアクセスできない場合の遷移先。アクセス可能なら null を返す。 */
export function mainViewRouteRedirect(
	auth: MainViewRouteAuthState,
	view: MainView,
	user: MainViewAccessUser,
): "/login" | "/" | null {
	if (auth !== "authenticated") return "/login";
	if (!canAccessMainView(view, user)) return "/";
	return null;
}
